<template>
  <div>
    <Breadcrumbs
      :breadcrumbs="[
     {title: this.$t(`menu.${serviceSlug}`), disabled: true},
     {title: this.$t('menu.leads-web/flows'), disabled: true}
   ]">
      <div slot="breadcrumbAfter" class="d-flex align-items-center">
        <Searchable class="mr-2" :querySearch.sync="querySearch" />
        <Filters
          :isActive="showFilters"
          :activeFilters="activeFilters"
          @toggle-filters="toggleFilters" />
      </div>
    </Breadcrumbs>

    <FadeTransition
      :duration="400"
      mode="out-in">
      <div class="btn btn__floating btn__round__large btn__round__large"
           v-if="writeEntities.length > 0">
        <va-popover
          :message="$t('leads-web.actions.create_flow')"
          placement="left"
        >
          <va-button
            @click.prevent="onClickCreateFlow">
            <i class="fa fa-plus"></i>
          </va-button>

        </va-popover>

      </div>
    </FadeTransition>

    <FlowsTable
      ref="leadsWebFlowsTable"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      :customQueries="customQueries"
      @filters-updated="onFiltersUpdated"
      @flowClicked="onFlowClicked"
    />

    <!--<ProjectsTable
      ref="iframeProjectsTable"
      :showFilters.sync="showFilters"
      :querySearch="querySearch"
      @filters-updated="onFiltersUpdated"
      @flowClicked="onFlowClicked"
      />

    <CreateProject
      v-if="showCreateFlow"
      :clientOptions="writeEntities"
      @cancel="onFlowCreateCancel"
      />-->
  </div>
</template>

<script>
import Breadcrumbs from "@/components/common/Breadcrumbs";
import Filters from "@/components/common/Filters";
import Searchable from "@/components/common/Searchable";
import IndexTablesMixin from "@/mixins/IndexTablesMixin";
import {TABLE_LEADS_WEB_FLOWS} from "@/local-storage/LocalStorageKeys";
import FadeTransition from "@/components/common/transitions/FadeTransition";
import FlowsTable from "@/components/leads-web/flows/FlowsTable";
export default {
  props: {
    serviceSlug: {
      type: String,
      required: true
    }
  },
  components: {FlowsTable, FadeTransition, Searchable, Filters, Breadcrumbs},
  mixins: [
    IndexTablesMixin
  ],
  data () {
    return {
      querySearch: '',
      showFilters: false,
      activeFilters: 0,
      localStorageKey: TABLE_LEADS_WEB_FLOWS,
      customQueries: null,
      selectedFlow: null,
      showCreateProject: false,
    }
  },
  methods: {
    onFlowClicked: function(row) {
      this.$router.push( `/${this.leadsWebService.slug}/${this.leadsWebService.slug}/flows/${row.id}` )
    },
    onFiltersUpdated: function (activeFilters) {
      this.activeFilters = activeFilters
    },
    toggleFilters: function () {
      this.showFilters = !this.showFilters
    },
    onClickCreateFlow: function () {
      this.showCreateProject = true
    },
    onFlowCreateCancel: function() {
      this.showCreateProject = false
    },
  },
  computed: {
    leadsWebService: function () {
      return this.$store.state.services.find(service => service.url === this.$store.state.leads_web_server) || null
    },
    flowPermissions: function () {
      if(this.leadsWebService) {
        return this.leadsWebService.user_permissions.filter(permission => permission.access_type >= 2 && permission.info_type === 210)
      }
      return []

    },
    entities: function () {
      if (this.leadsWebService) {
        return this.leadsWebService.entities
      }
      return []
    },
    writeEntities: function () {
      if(this.entities.length) {
        return this.entities.filter(entity => this.flowPermissions.some(permission => permission.entity_id === null || permission.entity_id === entity.id)) || []
      }
      return []
    }
  }
}
</script>

<style scoped>

</style>
